import React from 'react';
import './dashboard-sidebar.scss';
import { NavLink } from 'react-router-dom';

const DashboardSidebar = ({ isOpen }) => {
    return (
        <div className={`dashboard-sidebar ${isOpen ? 'open' : 'closed'}`}>
            <nav className="sidebar-nav">
                <ul>
                    <li>
                        <NavLink to="/user-dashboard" className={({ isActive }) => isActive ? 'active' : ''}>
                            <img src="/images/icons/dashboard-icon.svg" alt="icon" /> Dashboard
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/my-bookings" className={({ isActive }) => isActive ? 'active' : ''}>
                            <img src="/images/icons/my-bookings.svg" alt="icon" /> My Bookings
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/payments" className={({ isActive }) => isActive ? 'active' : ''}>
                            <img src="/images/icons/payment-methods.svg" alt="icon" /> Payments Method
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/support" className={({ isActive }) => isActive ? 'active' : ''}>
                            <img src="/images/icons/support.svg" alt="icon" /> Support
                        </NavLink>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default DashboardSidebar;
